import { Button, Col, Row } from 'antd';
import { FormattedMessage, injectIntl } from 'react-intl';
import React from 'react';
import { connect } from 'dva';
import PropTypes from 'prop-types';
import styles from '../styles.less';

function BottomActions({ goBack, backSuffix, nextSuffix }) {
  return (<Row type="flex" gutter={6} className={styles.bottomActionWrapper}>
    <Col span={12}>
      <Button type="default" onClick={goBack} style={{ width: '100%' }}>
        <FormattedMessage id={`Component.CreateHubspotTask.Form.${backSuffix}`} />
      </Button>
    </Col>
    <Col span={12}>
      <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
        <FormattedMessage id={`Component.CreateHubspotTask.Form.${nextSuffix}`} />
      </Button>
    </Col>
  </Row>);
}

BottomActions.propTypes = {
  goBack: PropTypes.func,
  backSuffix: PropTypes.string,
  nextSuffix: PropTypes.string,
};

export default connect()(injectIntl(BottomActions));



// WEBPACK FOOTER //
// ./src/components/Leads/Hubspot/CreateHubspotTransferModal/components/BottomActions.js